module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.sheetTitle) + "\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Species Available:")]), _vm._v(" "), (_vm.returns.species) ? _c('select', {
    ref: "species_selector",
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "species_selector",
      "id": "species_selector"
    }
  }, [(Object.values(_vm.returns.species_saved).length === 0) ? _c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.returns.species_list), function(specie, s_idx) {
    return _c('option', {
      key: ("specie_" + s_idx),
      staticClass: "change-species",
      attrs: {
        "species_id": s_idx
      },
      domProps: {
        "value": s_idx,
        "selected": s_idx === _vm.specie_selection
      }
    }, [_vm._v(_vm._s(specie))])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "name": "sheet_entry"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSheetRow()
      }
    }
  }, [_vm._v("New Entry")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Species already added for this Return:")]), _vm._v(" "), _vm._l((_vm.returns.species_saved), function(specie, a_idx) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }],
      key: ("selected_" + a_idx)
    }, [(a_idx === _vm.returns.species) ? _c('span', [_vm._v("   " + _vm._s(specie))]) : _c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "name": ("specie_link_" + a_idx)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getSheetSpecies(a_idx)
        }
      }
    }, [_vm._v(_vm._s(specie))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Activity Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterActivityType),
      expression: "filterActivityType"
    }],
    ref: "activity_filter_selector",
    staticClass: "form-control",
    attrs: {
      "name": "activity_filter_selector"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterActivityType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.sheet_activity_type), function(sa, sa_idx) {
    return _c('option', {
      key: ("sa_type_" + sa_idx),
      domProps: {
        "value": sa['label']
      }
    }, [_vm._v(_vm._s(sa['label']))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "return_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.sheet_options,
      "dtHeaders": _vm.sheet_headers
    }
  })], 1)])])]), _vm._v(" "), _c('SheetEntry', {
    ref: "sheet_entry"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aa2c009"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/enter_return_sheet.vue
// module id = 917
// module chunks = 0